import type { ActivityLogicPlugin } from '../../core/types/plugin.base.types';
import type { PercentGridPayload, PercentGridRuntime } from '../../core/types/payloads/percent_grid.types';
import type { HostActionPayload, StudentInputEnvelope } from '../../core/types/events.types';
import type { RoutingMode } from '../../core/types/room.types';
import { PercentGridPayloadSchema } from '../../core/schemas/examGenerationSchema';

export function validatePercentGridPayload(raw: unknown): PercentGridPayload {
  const parsed = PercentGridPayloadSchema.safeParse(raw);
  if (!parsed.success) {
    const first = parsed.error.issues[0];
    throw new Error(first?.message || 'PercentGrid payload invalid');
  }

  const data = parsed.data;
  return {
    instruction: data.instruction.trim(),
    percentage: Math.round(data.percentage),
  };
}

export function createInitialPercentGridRuntime(
  _payload: PercentGridPayload,
  _routing: RoutingMode,
): PercentGridRuntime {
  return { viewed: false };
}

export const percentGridLogic: ActivityLogicPlugin<'percent_grid'> = {
  mode: 'percent_grid',
  validatePayload: validatePercentGridPayload,
  createInitialRuntime: createInitialPercentGridRuntime,

  onStudentInput(ctx, input: StudentInputEnvelope) {
    if (input.action === 'EXAM_CONTINUE' || input.action === 'VIEW') {
      return { runtime: { ...ctx.runtime, viewed: true } };
    }
    return { runtime: ctx.runtime, rejected: true, rejectReason: 'UNKNOWN_ACTION' };
  },

  onHostAction(ctx, _action: HostActionPayload) {
    return { runtime: ctx.runtime };
  },
};

export function demoPercentGridPayload(): PercentGridPayload {
  return validatePercentGridPayload({
    instruction: '¿Qué porcentaje de la grilla está coloreado?',
    percentage: 35,
  });
}
